export default {
  API_ENDPOINT:'https://api.companycam.com/v2/projects/',
  expressUrl:'https://ccnode.fieldtech.io'||'http://localhost:8000'
}
